import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'app/core/modules/shared.module';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { FuseWidgetModule } from 'app/core/components/widget/widget.module';
import { AgmCoreModule } from '@agm/core';
import { environment } from '../../../../../../environments/environment';
import { StudentsComponent } from './students.component';
import { FuseAddorEditStudentComponent } from './components/add-student/add-student.component';
import { StudentService } from '../../../../services/students/student.service';
import { PersonGenderService } from '../../../../services/person-genders/person-gender.service';
import { DivisionService } from '../../../../services/divisions/division.service';
import { RelationshipService } from '../../../../services/relationships/relationship.service';
import { TutorService } from '../../../../services/tutors/tutor.service';
import { AuthenticationService } from '../../../../services/authentication/authentication.service';
import { ReportService } from '../../../../services/reports/report.service';
import { LightboxModule } from 'ngx-lightbox';
import { StudentExcelConfigurationComponent } from './components/student-excel-configuration/student-excel-configuration.component';
import { DocumentationService } from '../../../../services/documentations/documentation.service';
import { PaymentComponent } from './components/payment/payment.component';
import { PaymentConceptService } from '../../../../services/payment-concept/payment-concept.service';
import { ChangeCourseStudentComponent } from './components/change-course/change-course.component';
import { DivisionPaymentComponent } from './components/divisions-payments/division-payment.component';
import { DatePipe } from '@angular/common';
import { AddorEditPaymentComponent } from './components/payment/add-payment/add-payment.component';
import { HistoryStudentComponent } from './components/history/history-student.component';
import { PendingSubjectComponent } from './components/pending-subjects/pending-subject.component';

const routes = [
    {
        path: 'pages/management/students/:id',
        component: StudentsComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'PAGES_MANAGEMENT_STUDENTS',
                redirectTo: '/pages/errors/error-403'
            }
        }
    },
    {
        path: 'pages/management/students',
        component: StudentsComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'PAGES_MANAGEMENT_STUDENTS',
                redirectTo: '/pages/errors/error-403'
            }
        }
    },
    {
        path: 'pages/management/students/:id',
        component: StudentsComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
            permissions: {
                only: 'PAGES_MANAGEMENT_STUDENTS',
                redirectTo: '/pages/errors/error-403'
            }
        }
    }
];

@NgModule({
    declarations: [
        StudentsComponent,
        FuseAddorEditStudentComponent,
        AddorEditPaymentComponent,
        HistoryStudentComponent,
        StudentExcelConfigurationComponent,
        ChangeCourseStudentComponent,
        PaymentComponent,
        PendingSubjectComponent,
        DivisionPaymentComponent
    ],
    imports: [
        SharedModule,
        RouterModule.forChild(routes),
        FuseWidgetModule,
        LightboxModule,
        AgmCoreModule.forRoot({
            apiKey: environment.googleMapsApiKey
        })
    ],
    exports: [
        StudentsComponent
    ],
    entryComponents: [
        FuseAddorEditStudentComponent,
        AddorEditPaymentComponent,
        HistoryStudentComponent,
        StudentExcelConfigurationComponent,
        ChangeCourseStudentComponent,
        PaymentComponent,
        PendingSubjectComponent,
        DivisionPaymentComponent
    ],
    providers: [
        StudentService,
        PersonGenderService,
        DivisionService,
        RelationshipService,
        TutorService,
        ReportService,
        DocumentationService,
        PaymentConceptService,
        [DatePipe]
    ]
})

export class FuseStudentsModule {
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/students/students.module.ts